function handleSelectTwoFactorKind() {
  const $configTwoFactorAuthentication = $('.config-two-factor-authentication');

  if ($configTwoFactorAuthentication.length > 0) {
    const $pillsList = $('#two-factor-options-tab');

    $('a[data-toggle="pill"]').on('shown.bs.tab', (event) => {
      const $currentOtpKind = $(event.currentTarget);

      if ($currentOtpKind[0].classList.contains('active')) {
        const otpKind = $currentOtpKind.data('otp-kind');

        $.ajax({
          url: $pillsList.data('otp-kind-url'),
          type: 'PATCH',
          dataType: 'script',
          format: 'js',
          data: { [$pillsList.data('resource')]: { kind: otpKind } },
          beforeSend(xhr) {
            xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
          },
          error(data) {
            /* eslint-disable-next-line no-console */
            console.error('AJAX Error: ', JSON.stringify(data));
          },
        });
      }
    });
  }
}

$(document).ready(() => {
  handleSelectTwoFactorKind();
});
